import type {InviteApiModel} from '../../../../api/invite';

import {inviteStore} from '../../../../api/invite';
import {envManager} from '../../../../utils/env';
import {ResendInviteStrategy} from './ResendInviteStrategy';

export class ResendRegularInviteStrategy extends ResendInviteStrategy {
  constructor(private readonly invite: InviteApiModel) {
    super();
  }

  async resendInvite() {
    await inviteStore.delete(this.invite);

    if (envManager.isB2b) {
      await inviteStore.send({
        b2b: {
          emails: this.invite.email ? [this.invite.email] : undefined,
          message: this.invite.message,
          program_id: this.invite.program_id,
          user_ids: this.invite.user_id ? [this.invite.user_id] : undefined,
        },
      });
    } else if (this.invite.course_id) {
      await inviteStore.sendToCourse({
        course_id: this.invite.course_id,
        message: this.invite.message,
        program_id: this.invite.program_id!,
        recipients: [
          {
            email: this.invite.email ?? undefined,
            user_id: this.invite.user_id ?? undefined,
          },
        ],
      });
    } else {
      await inviteStore.sendToProgram({
        message: this.invite.message,
        program_id: this.invite.program_id!,
        recipients: [
          {
            email: this.invite.email ?? undefined,
            user_id: this.invite.user_id ?? undefined,
          },
        ],
      });
    }
  }
}
